import React from 'react';

const RectangleList = ({
  label,
  rectangleList,
  handleVariantChange,
  variantSpecs,
  id,
  styles,
  variants,
  track
}) => {
  const variant = variantSpecs?.find(tempVariant => tempVariant.option_id === id);

  const isOutOfStock = optionId => {
    if (!track) return false;

    return !!variants?.find(tempVariant => {
      if (tempVariant.option_values.length === 1) {
        const findOption = tempVariant.option_values.find(option => option.id === optionId);

        if (findOption && tempVariant.inventory_level === 0) {
          return true;
        }
      }
      return false;
    });
  };

  return (
    <div className={`${styles.optionList} ${styles.rectangleList}`}>
      <span className={styles.label}>{label}</span>
      <div className={styles.rectangleSelection}>
        {rectangleList?.map((option, index) => {
          const outOfStock = isOutOfStock(option.id);
          return (
            <div
              key={index}
              role="button"
              tabIndex={0}
              className={`${styles.rectangleOption} ${
                outOfStock ? styles.outOfStock : ''
              }  ${variant?.id === option?.id && styles.active}`}
              onClick={() => handleVariantChange(option)}
              onKeyDown={() => handleVariantChange(option)}
            >
              {option.label}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RectangleList;
